import { Bar } from "react-chartjs-2";

import ChartDataLabels from "chartjs-plugin-datalabels";
import Chart from "chart.js/auto";
import { useEffect, useState } from "react";
import { LANGuAGE_COOKIE } from "src/resources/constant";
import Cookies from "js-cookie";
import { isRtl } from "src/utils/helpers";
Chart.register(ChartDataLabels);
const BarChart = ({ chartData }: any) => {
  const [maxOpenATECases, setMaxOpenATECases] = useState<any>();

  useEffect(() => {
    const maxOpenATECases = Math.max(...chartData.datasets[0].data);
    setMaxOpenATECases(maxOpenATECases);
  }, [chartData]);
  const language = Cookies.get(LANGuAGE_COOKIE);
  const isRtlLanguage = isRtl(language);
  return (
    <Bar
      data={chartData}
      options={{
        responsive: true,
        maintainAspectRatio: false,

        plugins: {
          datalabels: {
            anchor: "end",
            align: "top",
            offset: 0,
            textAlign: "center",
            formatter: (value, context: any) => {
              const ctx = context.chart.ctx;
              ctx.save();
              const xPos = context.x;
              const yPos = context.y - 10;
              ctx.fillText(value?.toString(), xPos, yPos);
              ctx.restore();
            },
            font: {
              weight: "bold",
            },
          },
          title: {
            display: false,
          },
          legend: {
            display: false,
          },
          tooltip: { enabled: false },
        },
        indexAxis: "x",
        scales: {
          x: {
            reverse: isRtlLanguage,
            grid: {
              display: false,
            },
            ticks: {
              display: false,
            },
          },
          y: {
            suggestedMax: maxOpenATECases + maxOpenATECases / 4,
            grid: {
              display: false,
            },
            border: {
              dash: [2, 4],
              display: false,
            },

            ticks: {
              display: false,
              stepSize: 5,
            },
          },
        },
      }}
    />
  );
};

export default BarChart;
